/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useContext, useParams } from 'react';
import {
  CardElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';
import { Box, Button } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import { dataFetcher, endpoints, baseUrl } from 'Api';
import useSWR from 'swr';
import SubscriptionPage from './subscribe';
import TrialPage from './trial';
import TrialEndPage from './trial-end';
import './index.css';
import InputGrid from './components/input-grid';
import PaymentField from '../../../../private/settings/manage-payment-methods/AddCard/components/payment-field';

export default function CheckoutForm({ setIsToken, selected, purchasingProduct, setOpen, selectedPlan, totalTrialDays,
  updateDetails, contentId, setUploadModalVisibility }) {
  const { userDetails, setUserDetails, setAppSnackbar, getSubscription, setCurrentSelectedPlan, affiliateCode, apiResponse } = useContext(AppContext);
  const { forceAutoSignin, getToken } = useContext(AuthContext);
  const [email, setEmail] = useState(userDetails.email);
  const [firstName, setFirstName] = useState(userDetails.firstname);
  const [lastName, setLastName] = useState(userDetails.lastname);
  const [processing, setProcessing] = useState(false);
  const [cardNumber, setCardNumber] = useState(undefined);
  const [expirationDate, setExpirationDate] = useState(undefined);
  const [cvvNumber, setCvvNumber] = useState(undefined);
  const [paymentIsValid, setPaymentValidity] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { isValidating: updatingName, mutate: updateName } = useSWR([endpoints.updateMyProfile, firstName, lastName, affiliateCode], {
    fetcher: (url, inputFirstname, inputLastname, affiliateCode) => dataFetcher(url, { firstname: inputFirstname, lastname: inputLastname, affiliateCode }),
    onSuccess: ({ success }) => {
      if (success) {
        setUserDetails({ ...userDetails, firstname: firstName, lastname: lastName });
      }
    },
    onError: () => {
    },
  });
// const { isValidating: subscribingPlan, mutate: subscribePlan } = useSWR(
//   [
//     endpoints.subscribePlan,
//     selectedPlan,
//     0, // Set is_free to 0
//     affiliateCode, // Assuming afflitedCode holds the value you want to add
//   ],
//   {
//     fetcher: (url, parameters) => {
//       const [plan_id, is_free, afflitedCode] = parameters;
//       const data = { plan_id, is_free, affiliateCode };
//       return dataFetcher(url, data);
//     },
//     onSuccess: ({ success, message }) => {
//       if (success) {
//         getSubscription();
//         forceAutoSignin(); // Calls getmy profile api
//         setCurrentSelectedPlan(undefined);
//         if (contentId) {
//           // navigate(location.pathname);
//           updateDetails();
//         } else {
//           setAppSnackbar({
//             isVisible: true,
//             type: 'success',
//             message: 'Plan purchased successfully',
//           });
//           navigate(Pathname.dashboard);
//         }
//       } else {
//         forceAutoSignin(); // Calls getmy profile api
//         setAppSnackbar({
//           isVisible: true,
//           type: 'error',
//           message,
//         });
//       }
//     },
//     onError: (error, key) => {
//       forceAutoSignin(); // Calls getmy profile api
//       const responseData = error?.response?.data?.message;
//       console.error('error', error);
//       setAppSnackbar({
//         isVisible: true,
//         type: 'error',
//         message: responseData || 'Oops! Something went wrong while purchasing plan',
//       });
//     },
//   }
// );
const subscribePlan = async () => {
  try {
    const myToken = await getToken();
    const apiUrl = `${baseUrl}/subscribePlan`;
    const requestBody = {
      token: myToken,
      plan_id: 11,
      is_free: 0,
      // affiliateCode
    };
    const response = await axios.post(apiUrl, requestBody);
    getSubscription();
    forceAutoSignin(); // Calls getmy profile api
    setCurrentSelectedPlan(undefined);
    if (contentId) {
      // navigate(location.pathname);
      updateDetails();
    } else {
      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: 'Plan purchased successfully',
      });
      navigate(Pathname.dashboard);
    }
  } catch (error) {
    forceAutoSignin(); // Calls getmy profile api
    const responseData = error?.response?.data?.message;
    console.error('error', error);
    setAppSnackbar({
      isVisible: true,
      type: 'error',
      message: responseData || 'Oops! Something went wrong while purchasing plan',
    });
  }
};

  const { isValidating: addingCard, mutate: addCard } = useSWR([
    endpoints.addPaymentMethods, cardNumber, expirationDate?.split('/')[0], expirationDate?.split('/')[1], cvvNumber], {
    fetcher: (url, number, exp_month, exp_year, cvc) => dataFetcher(url, { number, exp_month, exp_year, cvc }),
    onSuccess: ({ success, message }) => {
      if (success) {
        subscribePlan();
        // closeAddCard();
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message,
        });
        setProcessing(false);
      }
    },
    onError: (error) => {
      const responseData = error?.response?.data?.message;
      setAppSnackbar({ isVisible: true, type: 'error', message: responseData || 'Oops! Something went wrong while adding new card' });
      setProcessing(false);
    },
  });

  const handleSubmiSub = async () => {
    setProcessing(true);
    updateName();
    addCard();
  };
  useEffect(() => {
    if (!purchasingProduct) {
      setProcessing(false);
    }
  }, [purchasingProduct]);
  return (
    // <form id="payment-form" onSubmit={handleSubmiSub}>
    <Box bgcolor="#FAFBFC">
      {selected?.isTrial !== 'No' ? (
        <SubscriptionPage
          afflitedDetails={apiResponse?.affDetails}
          setOpen={setOpen}
          userEmail={email}
          userFirstName={firstName}
          userLastName={lastName}
          setFirstName={setFirstName}
          setLastName={setLastName}
          purchasingProduct={processing}
          isDisabled={userDetails.firstname !== '' && userDetails.lastName !== ''}
          onContinue={handleSubmiSub}
          totalTrialDays={totalTrialDays}
          planId={selectedPlan}
        >
          <div className="card">
            <PaymentField
              onCardNumberChange={setCardNumber}
              onCvvNumberChange={setCvvNumber}
              onExpirationDateChange={setExpirationDate}
              setValidity={setPaymentValidity}
            />
          </div>
        </SubscriptionPage>
      )
        : (
          <SubscriptionPage
            afflitedDetails={apiResponse?.affDetails}
            setOpen={setOpen}
            userEmail={email}
            userFirstName={firstName}
            userLastName={lastName}
            setFirstName={setFirstName}
            setLastName={setLastName}
            purchasingProduct={processing}
            isDisabled={userDetails.firstname !== '' && userDetails.lastName !== ''}
            onContinue={handleSubmiSub}
            planId={selectedPlan}
          >
            <div className="card">
              <PaymentField
                onCardNumberChange={setCardNumber}
                onCvvNumberChange={setCvvNumber}
                onExpirationDateChange={setExpirationDate}
                setValidity={setPaymentValidity}
              />
            </div>
          </SubscriptionPage>
        )}

      {/* <TrialEndPage>
        <CardElement id="card-element" />
        {error && (
          <div className="card-error" style={{ color: 'red' }} role="alert">
            {error}
          </div>
        )}
      </TrialEndPage> */}
    </Box>
  );
}
